import { execFile } from 'node:child_process'
import { promisify } from 'node:util'
/**
 * Child processes here must not block the event loop: these steps run under a
 * spinner, and a synchronous `execFileSync` freezes its animation for the
 * whole (often multi-second) run, leaving the CLI looking hung.
 */
export const execFileAsync = promisify(execFile)
